export default {
  state: {
      isFeUserLoggedIn: false,
      feLoggedId: false,
  },
  getters: {
      feLoggedId: (state)=> {
          return state.feLoggedId;
      }
  },
  mutations: {
      setFeToken (state,token){
          state.token = token;
          if (token) {
              state.isFeUserLoggedIn = true;
          } else {
              state.isFeUserLoggedIn = false; 
          }
      },
      setFeUser (state,user) {
          state.user = user;
      },
      setFeLoggedId(state,loggedId) {
         
        state.feLoggedId = loggedId;
      },
      setFeLogout(state) {
          state.feLoggedId = false;
      } 
      
  },
  actions: {
      setFeToken ({commit},token) {
          commit('setToken',token)
      },
      setFeUser ({commit},user) {
          commit('setUser',user)
      },
      setFeLoggedId({commit},loggedId) {
        commit('setFeLoggedId',loggedId);
      }
  }
}